import styled, { css } from 'styled-components';
import { DottedLineProps, DottedLineVariant, ImgType } from './DottedLine';

export const Container = styled.div<DottedLineProps>`
	flex: 1;
	align-items: center;
	display: flex;
	position: relative;
	${({ onlyMobile }) =>
		!!onlyMobile &&
		css`
			@media (min-width: 769px) {
				display: none;
			}
		`};

	${({ variant }) =>
		variant === DottedLineVariant.Secondary &&
		css`
			height: 116px;
			${DottedLineImage} {
				margin: 0px;
				position: absolute;
			}
			margin: 0px;
		`};
`;
export const DottedLineImage = styled.div<Pick<DottedLineProps, 'filterColor' | 'img'>>`
	filter: ${({ filterColor }) => `${filterColor}`};
	width: 100%;
	${({ img }) =>
		img === ImgType.dottedLine &&
		css`
			background: url('/image/section-border-top-beige.png') repeat-x;
			height: 12px;
			margin: 20px 0;
		`};

	${({ img }) =>
		img === ImgType.dottedLineWithBorder &&
		css`
			background: url('/image/section-border-top.png') repeat-x;
			height: 33px;
		`};
`;
export const LogoImage = styled.img`
	height: 100%;
	max-width: 116px;
	max-height: 116px;
	margin: 0 auto;
	display: block;
	position: relative;
	border: 10px solid transparent;
	background-color: ${({ theme }) => theme.colors.secondary.light};
`;
